import { format } from 'date-fns';
import { motion } from 'framer-motion';

export type HealthTone = 'ok' | 'watch' | 'bad' | 'done' | 'muted';

const HEALTH_CHIP: Record<HealthTone, string> = {
  ok: 'border-[#a7f3d0] bg-[#ecfdf5] text-[#047857]',
  watch: 'border-[#fde68a] bg-[#fffbeb] text-[#b45309]',
  bad: 'border-[#fecdd3] bg-[#fff1f2] text-[#be123c]',
  done: 'border-[#bae6fd] bg-[#f0f9ff] text-[#0369a1]',
  muted: 'border-[#e2e8f0] bg-[#f8fafc] text-[#64748b]',
};

export function OverviewHeader({
  name,
  subLine,
  updatedAt,
  healthLabel,
  healthTone,
  progressPct,
}: {
  name: string;
  subLine: string;
  updatedAt?: string;
  healthLabel: string;
  healthTone: HealthTone;
  progressPct: number;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between"
    >
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#076333]">PMO · Project Workspace</p>
        <h3 className="mt-0.5 text-xl font-bold tracking-tight text-slate-900">{name}</h3>
        <p className="mt-0.5 text-[12.5px] text-slate-500">{subLine}</p>
      </div>
      <div className="flex items-center gap-2">
        {updatedAt && (
          <span className="text-[11px] text-[#94a3b8]">Updated {format(new Date(updatedAt), 'HH:mm')}</span>
        )}
        <span
          className={`rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.06em] ${HEALTH_CHIP[healthTone]}`}
        >
          {healthLabel} · {progressPct}%
        </span>
      </div>
    </motion.div>
  );
}
